import { ExclamationCircleIcon as ExclamationCircleIconOutline } from '@heroicons/react/24/outline';
import { Checkbox as CheckboxComponent } from '@praetorian-chariot/ui';
import { useEffect, useState } from 'react';

import { InputEvent, InputProps } from '@/components/form/Input';
import { Tooltip } from '@/components/Tooltip';
import { cn } from '@/utils/classname';

export const Checkbox = (props: InputProps) => {
  const {
    value,
    onChange,
    name,
    label,
    disabled,
    onClick,
    info,
    showTick,
    className,
  } = props;
  const [isChecked, setIsChecked] = useState<boolean>(value === 'true');
  const [showInfo, setShowInfo] = useState(false);

  // Sync local state with external value changes
  useEffect(() => {
    setIsChecked(value === 'true');
  }, [value]);

  const handleChange = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);

    // Immediately trigger the onChange event
    onChange({
      target: {
        value: newValue,
        name,
      },
    } as unknown as InputEvent);
  };

  return (
    <>
      <div className="flex items-center gap-1">
        <label
          className="flex items-center gap-2"
          data-testid="checkbox-label"
          role="checkbox"
          aria-checked={isChecked}
          aria-disabled={disabled}
        >
          <input
            type="checkbox"
            className={cn('hidden', isChecked ? 'isChecked' : 'isUnchecked')}
            checked={isChecked}
            onChange={handleChange}
            disabled={disabled}
            onClick={onClick}
          />
          <CheckboxComponent isChecked={isChecked} disabled={disabled} />
          <span
            className={cn(
              'text-chariot-text-primary block text-sm leading-6 font-medium',
              className
            )}
          >
            {label}
          </span>
        </label>
        {info && (
          <Tooltip placement="right" title={info?.text}>
            <ExclamationCircleIconOutline
              className="text-chariot-text-primary size-4"
              aria-hidden="true"
              onClick={() =>
                info.url ? window.open(info.url) : setShowInfo(info => !info)
              }
            />
          </Tooltip>
        )}
      </div>
      {info && info.content && showInfo && (
        <div
          className={
            'bg-chariot-background-secondary text-chariot-text-primary mt-2 rounded p-2 text-sm'
          }
        >
          {info.content}
        </div>
      )}
    </>
  );
};
